import { Pipe, PipeTransform } from '@angular/core';
import { LocationCategory } from 'src/app/features/charging-station-location/charging-station-location-model';

@Pipe({
  name: 'translateLocationCategoryEnum',
})
export class TranslateLocationCategoryEnum implements PipeTransform {
  transform(value: LocationCategory | null): string;
  transform(
    value: Array<{ index: number | string; name: number | string; value: number | string; label: number | string }>
  ): Array<{ index: number | string; name: string; value: number | string; label: string }>;
  transform(
    value:
      | Array<{ index: number | string; name: number | string; value: number | string; label: number | string }>
      | LocationCategory
      | null
  ): string | Array<{ index: number | string; name: string; value: number | string; label: string }> {
    if (Array.isArray(value)) {
      return value
        .map(item => {
          const key = String(item.value) as keyof typeof LOCATION_CATEGORY_NAMES;
          return {
            index: item.index,
            name: LOCATION_CATEGORY_NAMES[key] || '',
            value: item.value,
            label: LOCATION_CATEGORY_NAMES[key] || '',
          };
        })
        .sort((a, b) => a.label.localeCompare(b.label));
    }

    return value ? LOCATION_CATEGORY_NAMES[String(value) as keyof typeof LOCATION_CATEGORY_NAMES] || '' : '';
  }
}

const LOCATION_CATEGORY_NAMES: Record<LocationCategory, string> = {
  Workplace: 'Arbejdsplads',
  HousingAssociation: 'Boligforening',
  OnTheMove: 'På farten',
  Public: 'Det offentlige rum',
  Depot: 'Depot',
  ETruck: 'E-Truck',
};
